import React from 'react';
import { APP_MODAL_ROUTES, LOCATION_MANAGER_ROUTES } from '@/navigators/routes';
import {
  AppModalStackParams,
  LocationManagerStackParams,
} from '@/navigators/types';
import { CompositeNavigationProp, RouteProp } from '@react-navigation/native';
import { RestaurantInviteEmployee } from './restaurant-invite-employee';
import { StackNavigationProp } from '@react-navigation/stack';

interface Props {
  navigation: CompositeNavigationProp<
    StackNavigationProp<
      AppModalStackParams,
      APP_MODAL_ROUTES.RestaurantInviteEmployee
    >,
    StackNavigationProp<
      LocationManagerStackParams,
      LOCATION_MANAGER_ROUTES.InviteEmployee
    >
  >;
  route:
    | RouteProp<AppModalStackParams, APP_MODAL_ROUTES.RestaurantInviteEmployee>
    | RouteProp<
        LocationManagerStackParams,
        LOCATION_MANAGER_ROUTES.InviteEmployee
      >;
}

export const RestaurantInviteEmployeeScreen: React.FC<Props> = ({
  navigation,
  route,
}) => {
  return <RestaurantInviteEmployee {...route.params} navigation={navigation} />;
};
